const utils = {
  alphabeticSorting: (key, direction) => (a, b) => {
    let firstKey = a[key].toUpperCase();
    let secondKey = b[key].toUpperCase();

    if (!firstKey || !secondKey) {
      return -1;
    }

    if (firstKey > secondKey) {
      return direction ? 1 : -1;
    }

    if (firstKey < secondKey) {
      return direction ? -1 : 1;
    }

    return 0;
  },

  numericalSorting: (key, direction) => (a, b) => direction ? a[key] - b[key] : b[key] - a[key],

  replaceCommaWithDot: (string) => {
    string = string.toString();
    return Number(string.replace(/,/g, "."));
  },

  formatInputNumber: (textInput) => {
    const parsedText = utils.replaceCommaWithDot(textInput)
    if (!isNaN(Number(parsedText)))
      return parseFloat(parsedText)
    else return 0;
  },
}

export default utils;
